import apiClient from "../../../../../services/apiClient";

export async function getSpecializations() {

    const url = 'specializations';

    const ret = await apiClient.get(url);

    if(!ret || !ret.data) return [];

    return ret.data.filter(r=>r.isActive).map(r=>({ value: r._id, name: r.name }));
    
}


export async function getAcademicYears() {
    const url = 'references/academic-years?status=active';
    
    try {
        const ret = await apiClient.get(url);
        
        if (!ret || !ret.data || !ret.data.data) return [];
        
        return ret.data.data.map(year => ({
            value: year._id,
            name: year.name,
            year: year.additionalFields.year,
            groupFormationStart: year.additionalFields.groupFormationStart
        }));
    } catch (error) {
        console.error('Error fetching academic years:', error);
        return [];
    }
}